/*  */
// Minimal code highlighting implementation using CSS only
// Security: No external dependencies, no PHP-like tags in build files

// ----------------------------------------------------------------------

declare global {
  interface Window {
    highlightCode: (element: HTMLElement) => void;
  }
}

// Simple code highlighting function
const highlightCode = (element: HTMLElement) => {
  if (!element) return;

  // Add basic syntax highlighting classes
  element.classList.add('code-block');

  // Escape HTML to prevent XSS
  const content = element.textContent || '';
  element.textContent = content;
};

// Only expose to window in browser environment
if (typeof window !== 'undefined') {
  window.highlightCode = highlightCode;
}

// Add minimal CSS for code highlighting
const style = document.createElement('style');
style.textContent = `
  .code-block {
    background-color: #f5f5f5;
    border-radius: 4px;
    padding: 1rem;
    font-family: monospace;
    white-space: pre;
    overflow-x: auto;
  }
  .code-block .keyword { color: #0000ff; }
  .code-block .string { color: #008000; }
  .code-block .comment { color: #808080; }
  .code-block .number { color: #0000ff; }
`;
document.head.appendChild(style);

export { highlightCode };
/*  */